'use strict';
import orderList from './order-list';
import orderView from './order-view';
import clubBenefits from './benefits';

import { initLogin } from './user-login';

import productReturnForm from './product-return-form';
import marketingPermissions from './marketing-permissions';

export default function(API) {
	orderList(API);
	orderView(API);
	productReturnForm(API);
	clubBenefits(API);
	initLogin(API);

	if (document.querySelector('.club-login-page')) {
		import('./login').then(({ default: initLoginPage }) => {
			API.log('INIT club login');
			initLoginPage();
		});
	}
	marketingPermissions();

}
